import React, { memo } from 'react'
import { RadioGroup } from 'transfix-ui/components/RadioGroup'
import { IRateType } from 'apps/marketplace/store/contractLanes/types'
import { RATE_TYPES } from 'apps/marketplace/utils/constants/rates'
import { ChangeRateData } from 'apps/marketplace/utils/helpers/useCarrier'

interface IRateTypeProps {
  rateType?: IRateType
  hide: boolean
  onChange: (changes: Partial<ChangeRateData>) => void
}

export const RateType = memo<IRateTypeProps>(({ hide, onChange, rateType }) => {
  if (hide) {
    return <></>
  }

  const onRateTypeChange = ({ target: { value } }: { target: { value: string } }) => {
    onChange({ rateType: value })
  }

  return (
    <div className='row'>
      <div className='col-md-9' data-test='rate-type'>
        <RadioGroup
          label='Is this rate for a lane or a radius?'
          name='rateType'
          onOptionChange={onRateTypeChange}
          checked={rateType}
          stacked
          options={RATE_TYPES}
        />
      </div>
    </div>
  )
})
